import { GifsResult } from '@giphy/js-fetch-api'
import { IGif } from '@giphy/js-types'
import { Gif } from '@giphy/react-components'
import React, { useEffect, useState } from 'react'
import Loader from 'shared/components/brand-loader'
import AfterGif from 'shared/components/list-item-footer/list-item-footer'
import Observer from 'shared/components/observer'
import { getEmbedCode } from 'shared/util/gif-embed'
import { getSocialUrls, socialClick, SOCIAL_TYPES } from 'shared/util/gif-social'
import styled from 'styled-components'

const GifContainer = styled.div`
    margin-bottom: 30px;
    width: 480px;
`
const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
`
const Footer = styled(AfterGif)`
    width: 100%;
`

type Props = {
    className?: string
    fetchGifs: (offset: number) => Promise<GifsResult>
}

const Feed = ({ className, fetchGifs }: Props) => {
    const [gifs, setGifs] = useState<IGif[]>([])
    const doFetch = async (offset: number) => {
        const { data } = await fetchGifs(offset)
        setGifs(data)
    }
    useEffect(() => {
        doFetch(0)
    }, [])
    return (
        <Container className={className}>
            {gifs.map(gif => (
                <GifContainer key={gif.id}>
                    <Gif gif={gif} width={480} />
                    <Footer
                        items={[SOCIAL_TYPES.FACEBOOK, SOCIAL_TYPES.TWITTER, SOCIAL_TYPES.PINTEREST, SOCIAL_TYPES.LINK, SOCIAL_TYPES.EMBED]}
                        gif={gif}
                        getSocialUrls={getSocialUrls}
                        socialClick={socialClick.desktop}
                        getEmbed={getEmbedCode}
                    />
                </GifContainer>
            ))}
            {gifs.length > 0 && (
                <Observer onVisible={() => doFetch(gifs.length - 1)} key={gifs.length}>
                    <Loader />
                </Observer>
            )}
        </Container>
    )
}

export default Feed
